<div>
    <app-title title="합계보이기 / 감추기"></app-title>

    <div style="margin-bottom:15px;padding:0 20px; box-sizing: border-box;">
        <label  style="margin-left:0px;">합계위치 : </label>
        <select id="selMode" style="margin-left:10px;width:120px;" (change)="handleChange()" [(ngModel)]="selData">
            <option value="none">감추기</option>
            <option value="top">상단</option>
            <option value="bottom">하단</option>
        </select>
    </div>

    <div [id]="gridId" [style]="gridStyle"style=" padding:0 20px; box-sizing: border-box;"></div>
</div>